import { defineStore } from 'pinia';
import { ref } from 'vue';
import router from '@/router';
import { loginAdmin, logoutAdmin } from '@/api/adminAuth';

export interface AdminToken {
  key: string;
  refresh: string;
  expires: number | string;
  code?: string;
  adminIdx?: number;
}

export const adminAuthStore = defineStore(
  'adminAuth',
  () => {
    const login = ref(false);
    const key = ref('');
    const expires = ref<number | string>('');
    const refresh = ref('');
    const adminIdx = ref<number | null>(null);

    const setTokens = (token: AdminToken) => {
      login.value = true;
      key.value = token.key || '';
      refresh.value = token.refresh || '';
      expires.value = token.expires || '';
      adminIdx.value = token.adminIdx ?? null;
    };

    const reset = () => {
      login.value = false;
      key.value = '';
      expires.value = '';
      refresh.value = '';
      adminIdx.value = null;
    };

    const signIn = async (username: string, password: string) => {
      const res = await loginAdmin({ username, password });
      if (res?.data) {
        setTokens(res.data);
      }
      return res;
    };

    const signOut = async () => {
      try {
        if (key.value) {
          await logoutAdmin();
        }
      } finally {
        reset();
        router.replace('/inspirio-inc-admin/login');
      }
    };

    return { login, key, expires, refresh, adminIdx, setTokens, reset, signIn, signOut };
  },
  { persist: true },
);


